module.exports = __webpack_public_path__ + "static/media/congratulation.0831595a.png";